import React, { useEffect, useState } from 'react';
import { Table, Card, Spin, message, Button, Modal, Input, Form, Popconfirm, Tabs } from 'antd';
import api from '../api';

function BlackList() {
  const [userData, setUserData] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [ipData, setIpData] = useState([]);
  const [ipLoading, setIpLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('user');
  const [userForm] = Form.useForm();
  const [ipForm] = Form.useForm();
  const [addingUser, setAddingUser] = useState(false);
  const [addingIp, setAddingIp] = useState(false);

  const fetchUsers = () => {
    setUserLoading(true);
    api.get('/blacklist/users')
      .then(res => {
        setUserData(res.data?.data || res.data || []);
      })
      .catch(() => {
        message.error('Lỗi khi tải danh sách user!');
      })
      .finally(() => setUserLoading(false));
  };

  const fetchIps = () => {
    setIpLoading(true);
    api.get('/blacklist/ips')
      .then(res => {
        setIpData(res.data?.data || res.data || []);
      })
      .catch(() => {
        message.error('Lỗi khi tải danh sách IP!');
      })
      .finally(() => setIpLoading(false));
  };

  useEffect(() => {
    fetchUsers();
    fetchIps();
  }, []);

  const handleAddUser = (values) => {
    setAddingUser(true);
    api.post('/blacklist/users', values)
      .then(() => {
        message.success('Thêm user thành công!');
        handleCloseModal();
        fetchUsers();
      })
      .catch(() => {
        message.error('Thêm user thất bại!');
      })
      .finally(() => setAddingUser(false));
  };

  const handleAddIp = (values) => {
    setAddingIp(true);
    api.post('/blacklist/ips', values)
      .then(() => {
        message.success('Thêm IP thành công!');
        handleCloseModal();
        fetchIps();
      })
      .catch(() => {
        message.error('Thêm IP thất bại!');
      })
      .finally(() => setAddingIp(false));
  };

  const handleDeleteUser = (record) => {
    api.delete(`/blacklist/users/${record.id}`)
      .then(() => {
        message.success('Xóa user thành công!');
        fetchUsers();
      })
      .catch(() => {
        message.error('Xóa user thất bại!');
      });
  };

  const handleDeleteIp = (record) => {
    api.delete(`/blacklist/ips/${record.id}`)
      .then(() => {
        message.success('Xóa IP thành công!');
        fetchIps();
      })
      .catch(() => {
        message.error('Xóa IP thất bại!');
      });
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    userForm.resetFields();
    ipForm.resetFields();
  };

  const userColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: 'Tài khoản', dataIndex: 'account', key: 'account' },
    { title: 'Ngày thêm', dataIndex: 'createdAt', key: 'createdAt' },
    { title: 'Ngày cập nhật', dataIndex: 'updatedAt', key: 'updatedAt' },
    {
      title: 'Chức năng',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <Popconfirm title="Xác nhận xóa user này?" onConfirm={() => handleDeleteUser(record)} okText="Xóa" cancelText="Huỷ">
          <Button danger size="small">Xóa</Button>
        </Popconfirm>
      ),
    },
  ];

  const ipColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70 },
    { title: 'Địa chỉ IP', dataIndex: 'ip', key: 'ip' },
    { title: 'Ngày thêm', dataIndex: 'createdAt', key: 'createdAt' },
    { title: 'Ngày cập nhật', dataIndex: 'updatedAt', key: 'updatedAt' },
    {
      title: 'Chức năng',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <Popconfirm title="Xác nhận xóa IP này?" onConfirm={() => handleDeleteIp(record)} okText="Xóa" cancelText="Huỷ">
          <Button danger size="small">Xóa</Button>
        </Popconfirm>
      ),
    },
  ];

  const isUserModal = modalType === 'user';

  return (
    <Card title="Danh sách đen">
      <Tabs
        defaultActiveKey="user"
        items={[
          {
            key: 'user',
            label: 'User',
            children: (
              <>
                <Button type="primary" style={{ marginBottom: 16 }} onClick={() => { setModalType('user'); setModalOpen(true); }}>
                  Thêm user
                </Button>
                <Spin spinning={userLoading}>
                  <Table rowKey="id" columns={userColumns} dataSource={userData} pagination={false} />
                </Spin>
              </>
            ),
          },
          {
            key: 'ip',
            label: 'IP',
            children: (
              <>
                <Button type="primary" style={{ marginBottom: 16 }} onClick={() => { setModalType('ip'); setModalOpen(true); }}>
                  Thêm IP
                </Button>
                <Spin spinning={ipLoading}>
                  <Table rowKey="id" columns={ipColumns} dataSource={ipData} pagination={false} />
                </Spin>
              </>
            ),
          },
        ]}
      />
      <Modal
        open={modalOpen}
        title={isUserModal ? 'Thêm user vào danh sách đen' : 'Chặn IP'}
        onCancel={handleCloseModal}
        footer={null}
        destroyOnClose
      >
        {isUserModal ? (
          <Form form={userForm} layout="vertical" onFinish={handleAddUser}>
            <Form.Item name="account" label="Tài khoản" rules={[{ required: true, message: 'Nhập tài khoản!' }]}>
              <Input />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={addingUser} block>
                Thêm
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form form={ipForm} layout="vertical" onFinish={handleAddIp}>
            <Form.Item name="ip" label="Địa chỉ IP" rules={[{ required: true, message: 'Nhập IP!' }]}>
              <Input />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={addingIp} block>
                Thêm
              </Button>
            </Form.Item>
          </Form>
        )}
      </Modal>
    </Card>
  );
}

export default BlackList; 